import { parse } from "cookie"

import { UTM_PARAMS } from "@lib/constants"

export const getSessionCookie = (key: string): string | null => {
  if (typeof window === "undefined") {
    console.warn(`getSessionCookie called on server side, key: ${key}`)
    return null
  }

  const value = parse(document.cookie)[key]

  return value || null
}

export const getUtmParamSessionCookies = (): Record<string, string> => {
  const result: Record<string, string> = {}

  for (const key of UTM_PARAMS) {
    const value = getSessionCookie(key)
    if (value) {
      result[key] = value
    }
  }

  return result
}

export const setSessionCookie = (key: string, value: string, maxAgeSeconds?: number): void => {
  if (typeof window === "undefined") {
    console.warn(`setSessionCookie called on server side, key: ${key}`)
    return
  }

  try {
    const isSecure = process.env.NODE_ENV === "production" || window.location.protocol === "https:"
    const secureFlag = isSecure ? "Secure;" : ""
    const maxAgeFlag = maxAgeSeconds ? `max-age=${maxAgeSeconds};` : ""

    document.cookie = `${key}=${encodeURIComponent(value)}; path=/; SameSite=Strict; ${secureFlag} ${maxAgeFlag}`

    if (typeof BroadcastChannel !== "undefined") {
      const channel = new BroadcastChannel("auth-sync")
      channel.postMessage({ type: "COOKIE_CHANGE", key, value })
      channel.close()
    } else {
      window.dispatchEvent(new CustomEvent("cookieChange", { detail: { key, value } }))
    }
  } catch (error) {
    console.error(`Error setting session cookie for key ${key}:`, error)
  }
}

export const setPersistentCookie = (key: string, value: string): void => {
  setSessionCookie(key, value, 30 * 24 * 60 * 60) // 30 days
}
